import { SearchOrderGlobalBinded } from './../models/Orders_v2';
import { BillConceptos } from './../models/Factura';

export const ordersToConceptos = (orders: SearchOrderGlobalBinded[]) => {
    return orders.reduce((p, c) => {
        c.taxing.forEach((t, i) => {
            let valorUnitario = t.subtotal;
            // Check if IEPS applies
            const iepsTasa = t.taxes.filter(tax => tax.type === 'ieps').reduce((_p, tax) => _p += (tax.tasa || 0), 0);
            if (iepsTasa) {
                valorUnitario = valorUnitario / (1 + iepsTasa);
            }

            const entry: BillConceptos = {
                claveProdServ: '01010101',
                claveUnidad: 'ACT',
                descripcion: "venta",
                noIdentificacion: `${c.order.orderId}${i > 0 ? '-' + i : ''}`,
                valorUnitario: valorUnitario,
                cantidad: 1,
                impuestos: t.taxes.map((tax) => ({ type: tax.type, tasa: tax.tasa, retencion: tax.retencion || false, exento: tax.exento || false }))
            }
            p.push(entry);
        })
        return p;
    }, [] as BillConceptos[]);
}